// extracted by mini-css-extract-plugin
export default {"slipBody":"betSlipComponent_slipBody__e1+gu","slipFooter":"betSlipComponent_slipFooter__OilMe"};